import styled from 'styled-components'
import { CheckBox } from 'ui/components/CheckBox'

const WrappedCheckBox = styled(CheckBox)`
  margin: 0 12px 0 0;
`

export const s = {
  WrappedCheckBox
}
